export const getApi = async (url, token) => {
    let data;
    try {
        data = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+token,
            },
        });
    } catch (e) {
        
        return {
            "success": false,
            "data": null
        };
    }
    if (data.status === 200) {
        data = await data.json();
        return {
            "success": true,
            "data": data
        };
    }
    return {
        "success": false,
        "data": data
    };
}